<template>
  <span>
    <right-panel :id="`sidebar-create-task`" :class="styles" :styles="labelStyle" ref="task-panel" width="800px" :icon="'mdi mdi-plus'" :text="text" @hidden="onHidden">
      <div class="row">
        <div class="col-8 pl-5 ">
          <h6 class="mt-4">
            {{ $t("task.category") }}
            <right-panel
              class="float-right"
              id="sidebar-new-task-category"
              width="600px"
              :icon="'mdi mdi-plus'"
              :text="$t('task-menu.task-category.new')"
              @hidden="rightPanelClosed"
            >
              <div class="pl-5 pr-5">
                <Form />
              </div>
            </right-panel>
          </h6>
          <filter-select
            :validation="true"
            :isValid="!$v.form.category.$invalid"
            id="taskCategoryFilter"
            ref="taskCategoryFilter"
            :placeholder="$t('task.category')"
            :multiple="false"
            @filter="onCategorySearch"
            :selected="form.category"
            @changed="onCategorySelect"
          />

          <br />
          <sweet-input
            id="name"
            v-model="form.name"
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            layout="vertical"
            :placeholder="$t('common.name')"
            :label="$t('task.summary')"
            @focus="setActiveElement($event)"
          />
          <br />

          <sweet-textarea
            id="description"
            v-model="form.description"
            :isValid="!$v.form.description.$error"
            @input="$v.form.description.$touch()"
            type="text"
            layout="vertical"
            :placeholder="$t('common.description')"
            :label="$t('process.description')"
            :rows="3"
            @focus="setActiveElement($event)"
          />

          <div class="card card-body  mt-4">
            <h6>{{ $t("task.assignee-options.text") }}</h6>

            <div>
              <label class="mb-1" :class="form.assignToCausedAccount ? 'text-success' : ''">
                <b-form-checkbox v-model="form.assignToCausedAccount" switch size="sm" class="custom-checkbox-success">
                  <i class="bx bx-school"></i>
                  {{ $t("system-flow.assign.caused-account") }}
                </b-form-checkbox>
              </label>
            </div>

            <div>
              <label class="mb-1" :class="form.assignToOrganizationOwner ? 'text-success' : ''">
                <b-form-checkbox v-model="form.assignToOrganizationOwner" switch size="sm" class="custom-checkbox-success">
                  <i class="bx bx-school"></i>
                  {{ $t("task.assignee-options.organization-owner") }}
                </b-form-checkbox>
              </label>
            </div>

            <div>
              <label class="mb-1" :class="form.directAssign ? 'text-success' : ''">
                <b-form-checkbox v-model="form.directAssign" switch size="sm" class="custom-checkbox-success">
                  <i class="bx bx-school"></i>
                  {{ $t("task.assignee-options.selected-role") }}
                </b-form-checkbox>
              </label>
            </div>

            <div v-if="form.directAssign">
              <h6 class="mt-4">{{ $t("task.assignee-options.which-role") }}</h6>
              <filter-select
                id="roleFilter"
                ref="roleFilter"
                :placeholder="$t('role.text')"
                :searchable="false"
                :multiple="false"
                @filter="onRoleSearch"
                :selected="form.role"
                @changed="onRoleSelect"
              />
            </div>
          </div>

          <sweet-button @click="ok()" :disabled="$v.$invalid" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
            {{ $t("common.save") }}
          </sweet-button>
        </div>
        <div class="col-4">
          <h4>{{ $t("system-flow.task-definition-templates") }}</h4>
          <div class="d-flex flex-column">
            <div>
              <b-button variant="primary" class="btn btn-label btn-sm mr-1 mb-1" @click="applyTemplate('#organizasyon#')">
                <i class="bx bx-copy label-icon font-size-18"></i>
                {{ $t("organization.name") }}
              </b-button>
            </div>
            <div>
              <b-button variant="primary" class="btn btn-label btn-sm mr-1 mb-1" @click="applyTemplate('#varlık grupları#')">
                <i class="bx bx-copy label-icon font-size-18"></i>
                {{ $t("asset-group.plural") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </right-panel>
  </span>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";
import Form from "../../task/task-category/workspace-library-task-category-form.vue";

export default {
  props: ["store", "label", "labelStyle", "styles", "submitPrevent"],
  components: { SweetTextarea, Form },
  data() {
    return {
      selectedCompliancePolicy: undefined,
      form: {
        name: undefined,
        description: undefined,
        relatedQuestionSet: undefined,
        category: undefined,
        assignToCausedAccount: false,
        assignToOrganizationOwner: false,
        directAssign: false,
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      description: {
        required,
      },
      category: {
        required,
      },
    },
  },
  computed: {
    text() {
      return this.label || this.$t("task.create");
    },
    tasks() {
      return this.$store.getters[`${this.store}/tasks`];
    },
    editedTask() {
      return this.$store.getters[`${this.store}/editedTask`];
    },
  },
  watch: {
    editedTask: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = {};
        if (!v) {
          return;
        }
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
    "form.assignToCausedAccount": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToOrganizationOwner = false;
          this.form.directAssign = false;
        }
      },
    },
    "form.assignToOrganizationOwner": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToCausedAccount = false;
          this.form.directAssign = false;
        }
      },
    },
    "form.directAssign": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form.assignToOrganizationOwner = false;
          this.form.assignToCausedAccount = false;
        }
      },
    },
  },
  methods: {
    rightPanelClosed() {},
    onHidden() {
      this.form = {};
      if (!this.submitPrevent) {
        this.$store.commit(`${this.store}/editedTask`, undefined);
      }
    },

    async onCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`taskCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(item) {
      this.form = { ...this.form, category: item };
    },

    async onRoleSearch(value, callback) {
      const response = await this.$store.dispatch(`role/paginate`, {
        options: { limit: 200 },
        query: {},
      });

      callback(response.data?.docs ?? []);
    },
    onRoleSelect(item) {
      this.form = { ...this.form, role: { _id: item._id, name: item.name } };
    },

    ok() {
      try {
        const payload = {
          _id: this.form._id,
          name: {
            [this.currentLanguage]: this.form.name,
          },
          description: {
            [this.currentLanguage]: this.form.description,
          },
          category: this.form.category,
          assignToOrganizationOwner: this.form.assignToOrganizationOwner,
          assignToCausedAccount: this.form.assignToCausedAccount,
          role: this.form.role,
          directAssign: this.form.directAssign,
        };

        if (this.submitPrevent) {
          this.$emit("saved", payload);
          return;
        }

        if (this.editedTask) {
          this.$store.commit(`${this.store}/updateTaskItem`, { task: payload });
        } else {
          this.$store.commit(`${this.store}/addTaskItem`, { task: payload });
        }

        this.form = {};
        this.$root.$emit("bv::toggle::collapse", `sidebar-create-task`);
      } catch (error) {
        this.$emit("saved", undefined);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    closeTaskPanel() {
      this.$refs["task-panel"].$refs["sidebar-create-task"].hide();
    },
    setActiveElement(e) {
      this.elementName = e.id;
    },
    applyTemplate(value) {
      let element = document.getElementById(this.elementName);
      let startPos = element.selectionStart;
      let endPos = element.selectionEnd;
      let cursorPos = startPos;
      let tmpStr = element.value;

      if (value === null) {
        return;
      }

      value = `"${value}" `;
      this.form[this.elementName] = tmpStr.substring(0, startPos) + value + tmpStr.substring(endPos, tmpStr.length);

      setTimeout(() => {
        cursorPos += value.length;
        element.selectionStart = element.selectionEnd = cursorPos;
        this.$forceUpdate();
      }, 10);
    },
  },
};
</script>
